//!#system	

<template>
	<v-form ref="form" v-model="valid" lazy-validation autocomplete="off" @submit="submit">
		<v-card class="rounded-0" :loading="submitting">
			<v-card-title>
				<span class="headline">{{ title }}</span>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<v-alert v-if="errorState" :value="true" color="error" icon="mdi-alert" class="mr-4 ml-4">
					{{errorMessage}}
				</v-alert>
				<form-container
					v-model="updateModel"
					:routeInfo="routeInfo"
					context="update"
					:isBase="true"
				/>
				<div v-if="showTheJson" class="ml-4 mr-4 mt-4">
					<code style="width: 100%;">{{updateModel}}</code>
				</div>
				<input type="hidden" ref="hiddenInput" />
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn v-if="showTheJson" text @click="showTheJson = false;">Hide Data</v-btn>
				<v-btn v-if="!showTheJson" text @click="showTheJson = true;">View Data</v-btn>
				<v-btn text @click="closeDialog()">Exit</v-btn>
				<v-btn color="primary" :disabled="!valid" :loading="submitting" type="submit">Save</v-btn>
			</v-card-actions>
		</v-card>
	</v-form>
</template>
<script>
import apiService from '@/apiService';
import FormContainer from '@/components/forms/FormContainer';

export default {
	name: 'Update',
	components: {
		FormContainer
	},
	props: {
		currentData: {
			type: Object
		}
	},
	data() {
		return {
			valid: false,
			routeInfo: {
				namespace: 'uac', 
				title: 'Sign In', 
				name: 'signIn', 
				pluralName: 'signIns',
				basePath: 'admin/',
				id: this.currentData.id
			},
			errorState: false,
			errorMessage: '',
			// assemble the final JSON data here
			updateModel: {},
			showTheJson: false,
			submitting: false
		}
	},
	methods: {
		closeDialog() {
			this.$emit('close');
		},
		submit(e) {
			if (e) e.preventDefault();
			this.submitting = true;
			this.$refs.hiddenInput.focus();
			setTimeout(() => {
				if (this.$refs.form.validate()) {
					this.submitting = true;
					apiService.update({
						...this.routeInfo,
						body: this.updateModel
					}, (err, response, meta) => {
						this.submitting = false;
						if (err) {
							this.errorState = true;
							console.log('meta', meta);
							this.errorMessage = meta.validation.messages.join('\r\n');
							this.$store.dispatch('app/applyObjectError', {
								show: true,
								text: meta.validation ? meta.validation.messages.join('\n') : err 
							});
						}
						if (!err && response.id) {
							this.$store.dispatch('app/applyObjectUpdated', {
								show: true,
								text: this.titleUpdated
							});
							this.$refs.form.$el.reset();
							this.closeDialog();
							this.$emit('refresh');
						}
					});
				} else {
					this.submitting = false;
					this.errorState = true;
					this.errorMessage = 'Check the form fields to make sure you have entered everything correctly.';
				}
			}, 250);
		}
	},
	computed: {
		title() {
			return 'Update this Sign In'
		},
		titleUpdated() {
			return 'Your Sign In was updated.'
		}
	}
}
</script>